export default "__VITE_ASSET__DmNhyasq__"